//////////////////////////////////////////////////////////////////////////////
//
//  Push Campaign API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-29
//
//  설명: 푸시 캠페인 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 푸시 캠페인 관련 API
 */
const PushCampaignAPI: ApiGroup = {
    pagedList: {
        title: "푸시 캠페인 목록 조회",
        url: "/PushCampaign/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 푸시 캠페인 목록 조회",
        url: "/PushCampaign/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "푸시 캠페인 상세 조회",
        url: "/PushCampaign/{id}",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "푸시 캠페인 등록",
        url: "/PushCampaign",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "푸시 캠페인 수정",
        url: "/PushCampaign/{id}",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "푸시 캠페인 삭제",
        url: "/PushCampaign/{id}",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
    sendNow: {
        title: "푸시 캠페인 즉시 발송",
        url: "/PushCampaign/{id}/SendNow",
        method: "POST",
        paramz: {},
        pathParams: ["id"],
    },
    schedule: {
        title: "푸시 캠페인 예약 발송",
        url: "/PushCampaign/{id}/Schedule",
        method: "POST",
        paramz: {},
        pathParams: ["id"],
    },
    getHistory: {
        title: "캠페인 발송 이력 조회",
        url: "/PushCampaign/{id}/History",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
}

export default PushCampaignAPI
